export default {
  props: {
    styleObj: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      form: {}
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.form = this.styleObj;
    });
  },
  methods: {
    changeFun(type, e) {
      this.$message.destroy();
      if (type === 'disclosure' && !e.target.value) {
        if (this.form.controlsICPDisplay === false) {
          e.target.value = true;
          this.form.controlsDisclosurePageDisplay = true;
          this.$message.warning(this.$t('披露页、icp备案号不能同时取消勾选'));
          return;
        } else {
          this.form.controlsDisclosurePageExhibitor = 2;
        }
      } else if (type === 'icp' && !e.target.value) {
        if (this.form.controlsDisclosurePageDisplay === false) {
          e.target.value = true;
          this.form.controlsICPDisplay = true;
          this.$message.warning(this.$t('披露页、icp备案号不能同时取消勾选'));
          return;
        } else {
          this.form.controlsICPExhibitor = 2;
        }
      }
    }
  }
};